import React from "react"
export function ShortLayover(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M9.572 5.603l1.958.536a1 1 0 01.707 1.203l-1.229 4.993 1.266 1.287a1 1 0 01.287.701V18H11.06v-3.438l-2.563-2.616a1 1 0 01-.256-.939l.908-3.693-1.65.473v2.041H6V7.49a1 1 0 01.69-.951l2.883-.936zM8.076 13.1l1.103 1.134-.88 1.289a1 1 0 01-.826.436H5v-1.532h2.197l.88-1.327zm5.077-5.312l.74 1.528H16v1.537h-2.343a1 1 0 01-.919-.606l-.118-.275.533-2.184zM10.05 3.107a1.481 1.481 0 011.827-1.055 1.519 1.519 0 011.067 1.846 1.481 1.481 0 01-1.828 1.055 1.519 1.519 0 01-1.066-1.846z"
        fill="currentColor"
        id="prefix__short-layover"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
